/**
 * DocumentsAdmin Page
 *
 * Purpose: Page wrapper for DocumentsAdmin component with permission checks
 *
 * Features:
 * - Super admin access control
 * - Consistent with other admin page wrappers
 * - Provides page-level context for future enhancements
 *
 * Route: /admin/documents
 *
 * Permissions: Super Admin only (Global airline admin)
 */

import { useAirline } from '../../contexts/AirlineContext';
import DocumentsAdmin from '../../components/admin/DocumentsAdmin';

export default function DocumentsAdminPage() {
  const { isSuperAdmin } = useAirline();

  if (!isSuperAdmin) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <svg
              className="w-8 h-8 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Access Denied</h2>
          <p className="text-gray-600">
            You need super admin permissions to access the Document Library.
          </p>
        </div>
      </div>
    );
  }

  return <DocumentsAdmin />;
}
